import { refetchFunc } from 'modules/domain/common/hooks'
import { ProfileType, User } from 'modules/domain/user/types'
import styled from 'styled-components'
import { BlockUserButton } from './BlockUserButton'
import { KeyUserVerification } from './KeyUserVerification'
import { VerifiedByCoordinator } from './VerifiedByCoordinator'
import { VerifiedBySecurity } from './VerifiedBySecurity'
import { VerifiedUser } from './VerifiedUser'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 165px);
  gap: 16px;
`

type Props = {
  userDataRefetch: refetchFunc
  user: User
}

export const VerifyStatusList = ({ user, userDataRefetch }: Props) => {
  const canBeBidOwner = !![ProfileType.seller, ProfileType.customer, ProfileType.manager].find(
    (t) => t == user.profile?.profile_type,
  )
  const showVerifyList = canBeBidOwner && user.is_active

  return (
    <Wrapper>
      {showVerifyList && (
        <>
          {user.profile?.is_verified ? (
            <VerifiedUser
              coordinatorVerifiedDate={user.profile.verified_by_coordinator_at as string}
              securityVerifiedDate={user.profile.verified_by_security_at as string}
            />
          ) : (
            <>
              <VerifiedByCoordinator user={user} userRefetch={userDataRefetch} />
              <VerifiedBySecurity user={user} userRefetch={userDataRefetch} />
            </>
          )}
          <KeyUserVerification user={user} userRefetch={userDataRefetch} />
        </>
      )}
      <BlockUserButton user={user} userRefetch={userDataRefetch} />
    </Wrapper>
  )
}
